module.exports = __webpack_public_path__ + "img/DHL.9bd237c2.png";